const statusToneClassName = {
  success: "border-emerald-200 bg-emerald-50 text-emerald-700",
  error: "border-red-200 bg-red-50 text-red-700",
};

const buttonBaseClassName =
  "inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-medium transition disabled:cursor-not-allowed disabled:opacity-60";

const AnalyticsRebuildAction = ({
  filteredRangeLabel,
  fullRangeLabel,
  onOpenFiltered,
  onOpenFull,
  disabled = false,
  feedback,
}) => {
  return (
    <div className="rounded-3xl bg-white p-5 shadow">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
        <div className="space-y-1">
          <h2 className="text-lg font-semibold text-zinc-900">
            Analytics Maintenance
          </h2>
          <p className="text-sm text-zinc-500">
            Rebuild summary rows explicitly when you want to recalculate
            reporting data from successful payments using the stored
            <span className="mx-1 rounded bg-zinc-100 px-1.5 py-0.5 font-mono text-[11px] text-zinc-700">
              payment_month
            </span>
            buckets.
          </p>
          <p className="text-xs text-zinc-400">
            Selected range rebuild follows the current year and month filters.
            Category selection only affects the chart view.
          </p>
        </div>

        <div className="flex flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={onOpenFiltered}
            disabled={disabled}
            className={`${buttonBaseClassName} border border-zinc-200 bg-white text-zinc-800 hover:bg-zinc-50`}
          >
            Rebuild Selected Range
          </button>
          <button
            type="button"
            onClick={onOpenFull}
            disabled={disabled}
            className={`${buttonBaseClassName} bg-zinc-900 text-white hover:bg-zinc-800`}
          >
            Full Historical Rebuild
          </button>
        </div>
      </div>

      <div className="mt-4 grid gap-3 md:grid-cols-2">
        <div className="rounded-2xl border border-zinc-200 bg-zinc-50 px-4 py-3">
          <div className="text-xs font-semibold uppercase tracking-wide text-zinc-500">
            Selected Range
          </div>
          <div className="mt-1 text-sm font-medium text-zinc-800">
            {filteredRangeLabel}
          </div>
        </div>
        <div className="rounded-2xl border border-zinc-200 bg-zinc-50 px-4 py-3">
          <div className="text-xs font-semibold uppercase tracking-wide text-zinc-500">
            Full Historical Scope
          </div>
          <div className="mt-1 text-sm font-medium text-zinc-800">
            {fullRangeLabel}
          </div>
        </div>
      </div>

      {feedback?.message ? (
        <div
          className={`mt-4 rounded-2xl border px-4 py-3 text-sm ${
            statusToneClassName[feedback.tone] || statusToneClassName.success
          }`}
        >
          {feedback.message}
        </div>
      ) : null}
    </div>
  );
};

export default AnalyticsRebuildAction;
